/**
 * Petstyle24 – „Das könnte auch passen.“ (sections/related-products.liquid; D+E-Plan §5.5).
 *
 * <ps-recommendations> lädt in Bildnähe (IntersectionObserver, 1200 px Vorlauf) über die Shopify Product
 * Recommendations API. Alle Werte stammen aus den data-Attributen der tatsächlich gerenderten
 * Section-Instanz – keine hartcodierte Section- oder Template-ID:
 *   <data-url>?product_id=<data-product-id>&limit=<data-limit>&intent=related&section_id=<data-section-id>
 * Übernommen wird nur [data-ps-recommendations-content] derselben Instanz (Petstyle24.parseHTML,
 * importNode, gleiche Herkunft, kein innerHTML). Ohne Treffer oder bei Fehlern bleibt die Section
 * ohne Höhe; es wird nichts vorgetäuscht. Die Karten (context 'related') haben kein „Kaufen“ (M2.1).
 */
(() => {
  'use strict';

  const PS = window.Petstyle24;
  if (!PS || customElements.get('ps-recommendations')) return;

  class PsRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('is-pending') || this.requested) return;
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        // Großer Vorlauf: Die Section öffnet sich, bevor sie in den Sichtbereich kommt (keine sichtbare
        // Layoutverschiebung des Footers, 05c §5)
        { rootMargin: '0px 0px 1200px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async load() {
      this.requested = true;
      const url = PS.sameOriginUrl(this.dataset.url);
      const { sectionId, productId } = this.dataset;
      if (!url || !sectionId || !productId) return;
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', this.dataset.limit || '3');
      url.searchParams.set('intent', 'related');
      url.searchParams.set('section_id', sectionId);

      let html = null;
      try {
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) return;
        html = await response.text();
      } catch (error) {
        return;
      }

      const fresh = PS.parseHTML(html).querySelector('[data-ps-recommendations-content]');
      if (!fresh || !fresh.querySelector('.product-card')) return;
      fresh.querySelectorAll('noscript').forEach((node) => node.replaceChildren());

      const current = this.querySelector('[data-ps-recommendations-content]');
      if (!current) return;
      current.replaceWith(document.importNode(fresh, true));
      this.classList.remove('is-pending');
      PS.emit('recommendations:loaded', { sectionId });
    }
  }

  customElements.define('ps-recommendations', PsRecommendations);
})();
